define('views/sidebar',['require','jquery','mediator','views/base/view','text!templates/sidebar.ejs','views/widgets/account','views/widgets/currency','views/widgets/manager','views/widgets/multi-account'],function(require) {
    'use strict';

    var $ = require('jquery'),
        mediator = require('mediator'),
        View = require('views/base/view'),
        template = require('text!templates/sidebar.ejs'),
        AccountWidgetView = require('views/widgets/account'),
        CurrencyWidgetView = require('views/widgets/currency'),
        ManagerWidgetView = require('views/widgets/manager'),
        MultiAccountWidgetView = require('views/widgets/multi-account');

    var SidebarView = View.extend({
        autoRender: true,
        className: 'sidebar',
        id: 'main-sidebar',
        template: template,
        region: 'sidebar',

        regions: {
            'account-widget': '#menu-items',
            'currency-widget': '#menu-items',
            'manager-widget': '#menu-items',
            'multi-account-widget': '#menu-items'
        },

        listen: {
            'signinStatus mediator': 'render'
        },

        initialize: function () {
            View.prototype.initialize.apply(this, arguments);
            this.model = mediator.sidebar;
            this.delegate('click', '.rollbtn', this.onClick);
            this.listenTo(mediator.userSettings, 'change:sidebarExpanded', this.updateExpanded);
        },

        getTemplateData: function() {
            var object = View.prototype.getTemplateData.apply(this, arguments);
            return object;
        },

        render: function () {
            View.prototype.render.apply(this, arguments);
            this.updateExpanded();

            if (mediator.isAuthorized()) {
                this.subview('account-widget', new AccountWidgetView({ model: this.model.account, region: 'account-widget' }));
                this.subview('multi-account-widget', new MultiAccountWidgetView({ model: this.model.multiAccount, region: 'multi-account-widget' }));
                this.subview('currency-widget', new CurrencyWidgetView({ model: this.model.currency, region: 'currency-widget' }));
                this.subview('manager-widget', new ManagerWidgetView({ model: this.model.manager, region: 'manager-widget' }));
            }

            return this;
        },

        onClick: function() {
            var settings = mediator.userSettings;

            settings.set('sidebarExpanded', !settings.get('sidebarExpanded'));
            mediator.userSettings.save();
        },

        updateExpanded: function() {
            if (!mediator.user) { return; }

            var settings = mediator.userSettings;

            var method = settings.get('sidebarExpanded') ? 'removeClass' : 'addClass';

            $('#main-content-container')[method]('collapsed');
            $('#breadcrumb-container')[method]('collapsed');
            $('#main-sidebar-container')[method]('collapsed');
            $('#scroll-btn')[method]('collapsed');

        }
    });

    return SidebarView;
});
